const apiHost = 'https://aim.echotech.site';

export const environment = {
  apiHost: apiHost,
  apiUrl: `${apiHost}/api/v1`
};
